import React from "react";
import Skeleton from "react-loading-skeleton";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Checkbox } from "../../atoms/Checkbox/Checkbox.component";
import S from "./CheckboxList.module.scss";

export interface DA_CheckboxListProps {
    title?: React.ReactNode;
    checkboxList?: DA_CheckboxType[];
    className?: string;
    onChange: (newList: DA_CheckboxType[]) => void;
    isLoading?: boolean;
}

export type DA_CheckboxType = {
    label: string;
    name: string;
    value: string;
    checked: boolean;
};

export const DA_CheckboxList = ({
    title,
    checkboxList,
    className,
    onChange,
    isLoading,
}: DA_CheckboxListProps) => {
    const handleOnChange = (index, state) => {
        const newList = [...checkboxList];
        newList[index].checked = state;
        onChange(newList);
    };

    return (
        <div className={cn(className, S.wrapper)}>
            {title && <strong>{title}</strong>}
            {isLoading && <Skeleton width="100%" />}
            {!isLoading && (
                <div className={S.checkboxList}>
                    {checkboxList.map((item, itemIndex) =>
                        isLoading ? (
                            <Skeleton key={`skeleton-${itemIndex}`} width="100%" />
                        ) : (
                            <DA_Checkbox
                                key={itemIndex}
                                label={item.label}
                                value={item.value}
                                name={item.name}
                                checked={item.checked}
                                onChange={(state) => handleOnChange(itemIndex, state)}
                                className={S.checkbox}
                            />
                        )
                    )}
                </div>
            )}
        </div>
    );
};
